import { apiService } from "@/services";
import { settings } from "@/settings";
import { AllocationSystemsClient } from "./GeneratedClients";

const allocationSystemRepository = new AllocationSystemsClient(settings.webApi.baseUrl, apiService.getApiClient());

export { allocationSystemRepository };
